import type { StayCollectionResult } from "~/types/finance";

export function emptyStayCollectionResult(
  visible = false,
): StayCollectionResult {
  return {
    neverPaid: [],
    inProgress: [],
    counts: { neverPaid: 0, inProgress: 0 },
    visible,
  };
}
